import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/form-footer.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/form-footer.css');

export const FormFooterDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css}>
    <p>
      You may want to put some saving progress or validation feedback in a
      form&rsquo;s footer. Here&rsquo;s how you can visually split this
      information apart from your form buttons, with essentially the same markup
      structure and styles as in the Site Header example.
    </p>
  </DemoPage>
);

FormFooterDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/FormFooterDemo.js